import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PublicRoute = () => {
    const { isLoggedIn } = useAuth();
    return !isLoggedIn ? (<Outlet/>) : (<Navigate to={'/dashboard'}/>);
};

export default PublicRoute;